var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_circle_black_24dp_3_",
    "data-name": "account_circle_black_24dp (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.504,
    height: 33.504,
    viewBox: "0 0 33.504 33.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M0,0H33.5V33.5H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M15.96,2A13.96,13.96,0,1,0,29.92,15.96,13.965,13.965,0,0,0,15.96,2ZM9.078,24.727c.6-1.256,4.258-2.485,6.882-2.485s6.3,1.228,6.882,2.485a11.064,11.064,0,0,1-13.765,0ZM24.838,22.7c-2-2.429-6.84-3.253-8.879-3.253s-6.882.824-8.879,3.253a11.168,11.168,0,1,1,17.757,0ZM15.96,7.584a4.886,4.886,0,1,0,4.886,4.886A4.874,4.874,0,0,0,15.96,7.584Zm0,6.98a2.094,2.094,0,1,1,2.094-2.094A2.091,2.091,0,0,1,15.96,14.564Z",
    transform: "translate(0.792 0.792)",
    fill: "#eb8eba"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.fbff4f14a7fa623f37f0e4fab03a030e.svg";
export { ForwardRef as ReactComponent };